
import React, { createRef, useEffect, useState } from "react";
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './_css/index.css';
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Routes, Route, Link, Navigate } from "react-router-dom";

import Login from './login';
import Home from './home';
import Manage from './View/admin/main/index';

import Hidden from '@mui/material/Hidden';
import {
    drawerWidth,
    appbarHeight
} from "./assets/jss/psstyle/psacount";
import AccountMenu from './Components/Navbars/Acountmenu';
import parseJwt from "./CustomFunction/parseJWT.js";
import Logout from "./CustomFunction/User/logout"
import { styled, useTheme } from '@mui/material/styles';
import styles from "./assets/jss/psstyle/component/headerStyle"
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Adminslidbar from "./Components/Slidebar/Adminslidbar";
import { genURL } from "./_getjson";
import axios from "axios";
// const drawerWidth = 320;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(0),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
        width: `calc(100% - ${drawerWidth}px)`,
        height: "100vh",
        overflowY: "auto"
    }),
);
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    height: appbarHeight,
    ...styles.appBar,
    display: "flex"
}));
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    height: appbarHeight,
    ...styles.DrawerHeader,
}));
//   page  
var RouterPath;
if (!localStorage.getItem("Token")) {
    RouterPath = <Route path="/login" component={Login} />
} else {
    var RouterPath = <>
        <Route index path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path='/manage' element={<Manage />} />
        <Route path="*" element={<NoMatch />} />
    </>
}
async function NoMatch() {
    console.log("localStoragegetItemToken", localStorage.getItem('Token'))
    if (localStorage.getItem('Token')) {
        let datenow = Math.round((new Date()).getTime() / 1000)
        let dateExp = parseJwt(localStorage.getItem('Token')).exp
        console.log("localStoragegetItemToken ", dateExp);
        console.log("localStoragegetItemToken datenow", datenow);
        if (datenow > dateExp) {
            Logout()
            // window.location.href = '/login'
        } else {
            window.location.href = '/home'
        }
    } else {
        console.log("else");
        Logout()
        //window.location.href = '/login'
    }
}
export default function adminlayout({ ...rest }) {
    const theme = useTheme();
    // styles
    const [open, setOpen] = React.useState(false);
    const [openToggle, setOpenToggle] = React.useState(false);
    const [categoryreport, setCategoryreport] = React.useState([]);
    React.useEffect(() => {
        // Update the document title using the browser API
        checkOpenToggle()
        getCategory()
        return () => { };
    }, []);
    const getCategory = async () => {
        let url = "/reportmanage/category?"
        let elementcategory = []
        await axios.get(genURL(url)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("resdata", res.data)
            // elementcategory = res.data
            // console.log("resdata", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    if (res.data[index].catelevel == 0) {
                        elementcategory.push(res.data[index])
                    }
                }
            }
        }).catch(error => {
            console.log("resdata", error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
        await console.log("elementcategory", elementcategory)
        await setCategoryreport(elementcategory)
    }
    const checkOpenToggle = () => {
        console.log("checkOpenToggle", localStorage.getItem("OpenToggle"));
        if (localStorage.getItem("OpenToggle") === "false") {
            setOpen(false)
        } else {
            setOpen(false)
        }
    }
    const toggleDrawer = (open) => (event) => {
        setOpen(open)
        // localStorage.setItem("OpenToggle", open)
        // console.log("OpenToggle toggleDrawer", open);
    };
    const handleDrawerOpen = () => {
        setOpen(true);
        localStorage.setItem("OpenToggle", "true")
        console.log("OpenToggle handleDrawerOpen");
    };
    const handleDrawerClose = () => {
        setOpen(false);
        localStorage.setItem("OpenToggle", "false")
        console.log("OpenToggle handleDrawerClose");
    };
    const handleDrawerToggle = () => {
        setOpenToggle(!openToggle)
        console.log("OpenToggle handleDrawerToggle");
    };

    return (
        <>
            <Box sx={{ display: 'flex', flexGrow: 1 }}>
                <CssBaseline />
                <AppBar position="static" open={open}  >
                    <Toolbar>
                        {localStorage.getItem("Token") !== null ?
                            <>
                                <Box component="div" sx={{ flexGrow: 1 }}>
                                    {/* <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={handleDrawerOpen}
                                        edge="start"
                                        sx={{ mr: 2, ...(open && { display: 'none' }) }}
                                    >
                                        <MenuIcon />
                                    </IconButton> */}
                                </Box>
                                <Box>
                                    <Hidden mdDown implementation="css">
                                        <AccountMenu categoryReport={categoryreport} />
                                    </Hidden>
                                    <Hidden mdUp implementation="css">
                                        <IconButton
                                            color="inherit"
                                            aria-label="open drawer"
                                            onClick={handleDrawerToggle}
                                        >
                                            {/* <AccountMenu /> */}
                                            <MenuIcon />
                                        </IconButton>
                                    </Hidden>
                                </Box>
                            </> : ""}

                    </Toolbar>
                </AppBar>
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            overflowY: 'hidden',
                            overflowX: 'hidden',
                            display: 'flex'
                        },

                    }}
                    variant="persistent"
                    anchor="left"
                    open={open}
                >
                    <DrawerHeader>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    {/* <Adminslidbar /> */}
                </Drawer>
                {/* end Drawer left */}

                <Main open={open}>
                    <DrawerHeader />
                    <Routes>
                        {RouterPath}
                    </Routes>
                </Main>
            </Box >
            <div>
                <React.Fragment key={"top"}>
                    <SwipeableDrawer
                        anchor={"top"}
                        open={openToggle}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >
                        <Box sx={{ ...styles.SwipeableDrawer }}>
                            <AccountMenu categoryReport={categoryreport} />
                        </Box>
                    </SwipeableDrawer>
                </React.Fragment>

            </div>

        </>
    )
}